import { Toaster } from 'react-hot-toast';

const TOASTER_OPTIONS = {
  duration: 4000,
  style: {
    background: '#CAEEB0',
    color: '#151529',
  },
  success: {
    duration: 3000,
    iconTheme: {
      primary: '#4ade80',
      secondary: '#fff',
    },
    style: {
      background: '#CAEEB0',
      color: '#151529',
      maxWidth: '500px',
    },
  },
  error: {
    style: {
      background: '#F9DEDC',
      color: '#8C1D18',
      maxWidth: '500px',
    },
  },
} as const;

export const AppToaster = () => (
  <Toaster position='top-center' toastOptions={TOASTER_OPTIONS} />
);
